export const TrashIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={17} height={17} viewBox="0 0 17 17" fill="none" {...props}>
    <g
      clipPath="url(#a)"
      stroke="#71717A"
      strokeWidth={1.5}
      strokeLinecap="round"
    >
      <path d="m13.59 4.38-.413 6.683c-.106 1.707-.159 2.561-.587 3.175-.211.303-.484.56-.8.752-.639.39-1.494.39-3.205.39-1.713 0-2.57 0-3.21-.39a2.7 2.7 0 0 1-.8-.754c-.427-.615-.48-1.47-.582-3.18L3.59 4.38m-1 0h12m-3.297 0-.455-.94c-.302-.623-.453-.935-.714-1.13a1.3 1.3 0 0 0-.183-.114c-.289-.15-.635-.15-1.328-.15-.71 0-1.066 0-1.36.156a1.3 1.3 0 0 0-.185.12c-.264.202-.411.525-.706 1.171l-.404.886m.965 7.334v-4m3.333 4v-4" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M.59.713h16v16h-16z" />
      </clipPath>
    </defs>
  </svg>
);
